import {
  flexRender,
  getCoreRowModel,
  useReactTable,
  type ColumnDef,
} from '@tanstack/react-table';
import { Table } from '@yaradigitallabs/ahua-react';
import { useEffect, useState } from 'react';
import type { BackfillExecutions } from '../types/backfill.types';
import { backfillColumns } from './BackfillColumns';
import { useAppSelector } from '@/app/hooks.ts';
import { BackfillTableSkeleton } from '@/components/skeleton';

export const BackfillTable = ({
  handlePaginationChange,
}: {
  handlePaginationChange: (val: { size: number; page: number }) => void;
}) => {
  const { executions, loading } = useAppSelector(state => state.backfill);
  const [data, setData] = useState<BackfillExecutions[]>([]);

  useEffect(() => {
    if (executions) {
      setData(executions);
    }
  }, [executions]);

  const table = useReactTable({
    data: data,
    columns: backfillColumns as ColumnDef<BackfillExecutions, any>[],
    getCoreRowModel: getCoreRowModel(),
    debugTable: false,
  });

  return (
    <div className="w-full items-center justify-center">
      {loading ? (
        <BackfillTableSkeleton />
      ) : (
        <>
          <Table css={{ width: '100%' }}>
            <thead>
              {table.getHeaderGroups().map(headerGroup => (
                <Table.Row key={headerGroup.id}>
                  {headerGroup.headers.map(header => (
                    <Table.SortHead
                      key={header.id}
                      css={{ paddingTop: '4px', paddingBottom: '4px' }}
                      className="pl-3 pr-2 border-t border-r border-l border-[#E5E7EB]"
                    >
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                    </Table.SortHead>
                  ))}
                </Table.Row>
              ))}
            </thead>
            <tbody>
              {data.length === 0 ? (
                <Table.Row>
                  <Table.Cell
                    colSpan={backfillColumns.length}
                    className="text-center py-8"
                  >
                    No backfill records found.
                  </Table.Cell>
                </Table.Row>
              ) : (
                table.getRowModel().rows.map(row => (
                  <Table.Row key={row.id}>
                    {row.getVisibleCells().map(cell => (
                      <Table.Cell key={cell.id}>
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </Table.Cell>
                    ))}
                  </Table.Row>
                ))
              )}
            </tbody>
          </Table>
        </>
      )}
    </div>
  );
};
